export const AUTHORIZATION_HEADER = 'Authorization';
export const SESSION_TOKEN_HEADER = 'x-session-token';
export const SUBSCRIPTION_KEY_HEADER = 'ocp-apim-subscription-key';
export const ORIGIN_IP_HEADER = 'X-Origin-Id';
